import React, { createContext, useContext, useState, ReactNode } from 'react';

type SidebarContextType = {
    closeSidebar: () => void;
};

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export function SidebarProvider({ children, onClose }: { children: ReactNode; onClose: () => void }) {
    return (
        <SidebarContext.Provider value={{ closeSidebar: onClose }}>
            {children}
        </SidebarContext.Provider>
    );
}

export function useSidebar() {
    const context = useContext(SidebarContext);
    if (context === undefined) {
        return { closeSidebar: () => {} }; // Default no-op function
    }
    return context;
}

